import styled from 'styled-components';
import { Textarea } from '@chakra-ui/textarea';

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const CustomTextArea = styled(Textarea)`
  border-radius: 4px !important;
  border-color: ${({ theme }) => theme.colors.gray600};
`;
